<div class="disclosures-v4">
  <div class="disclosures-v4__container">
    <h2 class="disclosures-v4__title">{{ content?.disclosures }}</h2>
    <div class="disclosures-v4__content">
      <p class="disclosures-v4__paragraph">{{ content?.disc1 }}</p>
      <p class="disclosures-v4__paragraph">{{ content?.disc2 }}</p>
      <p class="disclosures-v4__paragraph">{{ content?.disc3 }}</p>
    </div>
  </div>
</div>
